import { Component, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { LoginService } from '../../../services/login.service';
import { Router } from '@angular/router';import { EncryptionService } from 'src/app/services/encryption.service';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  visibleSideBar: boolean = false;
  visibleMenu : boolean = false;
  menuItems: MenuItem[];
  profilItems: MenuItem[];
  collapsedMenuItems : MenuItem[];
  dynamicItems : any[] = [];

 constructor(private router: Router, private loginService: LoginService,private encryptService:EncryptionService) { }
 showAcceuil: boolean;
  showModeration: boolean;
  showHistorique: boolean;
  showReporting: boolean;
  showFacturation: boolean;
  showSupervision: boolean;
  showAdministration: boolean;
  showPerformance: boolean = true;
  ngOnInit(): void {
    this.visibleSideBar = false;
    this.dynamicItems = this.buildMdenu();

    this.menuItems = [
      {
        label: 'ADMINISTRATION',
        items: [
          {label:"Gestion utilisateurs", icon:"pi pi-fw pi-users", routerLink:'/administration'},
       //   {label:"Gestion planning", icon:"pi pi-fw pi-calendar", routerLink:'/planing'},
          {label:"Import fiches", icon:"pi  pi-file-excel", routerLink:'/import'},
          {label:"Gestion fiches", icon:"pi  pi-file-o", routerLink:'/brouillons'},
          {label:"Echantillonnage", icon:"pi  pi-star-o", routerLink:'/echantillonage'},
          {label:"Logs", icon:"pi  pi-info-circle", routerLink:'/logs'},
          {label:"Envoi manuel", icon:"pi pi-compass", routerLink:'/envoi'},
        ]
      }
    ];
    this.profilItems = [
      {
        label: 'PROFIL',
        items: [
          {label:"Changer mot de passe", icon:"pi pi-fw pi-lock", routerLink:'/password'}
        ]
      }
    ];

    this.collapsedMenuItems = [
      {
        label: 'PROFIL',
        items: [
          {label:"Changer mot de passe", icon:"pi pi-fw pi-lock", routerLink:'/password'}
        ]
      },

      {
        label: 'NAVIGUER',
        items: this.dynamicItems
      }
    ]
    /**
     *  Verification droit Menu
     */
    let id_droit= parseInt(( JSON.parse(this.encryptService.decrypt(localStorage.getItem("user"))).droit ));
    switch (id_droit) {
      case 1:
      {
        this.showAcceuil = false;
        this.showModeration = true;
        this.showHistorique = true;
        this.showReporting = true;
        this.showFacturation = true;
        this.showSupervision = true;
        this.showAdministration = true;
        break;
      }
      case 2:
      {
        this.showAcceuil = false;
        this.showModeration = true;
        this.showHistorique = true;
        this.showReporting = true;
        this.showFacturation = true;
        this.showSupervision = true;
        this.showAdministration = true;
        break;
      }
      case 3:
      {
        this.showAcceuil = false;
        this.showModeration = false;
        this.showHistorique = true;
        this.showReporting = true;
        this.showFacturation = true;
        this.showSupervision = true;
        this.showAdministration = false;
        this.showPerformance = false;
        break;
      }
      case 4:
      {
        this.showAcceuil = false;
        this.showModeration = true;
        this.showHistorique = true;
        this.showReporting = false;
        this.showFacturation = false;
        this.showSupervision = false;
        this.showAdministration = false;
        break;
      }
      case 5:
      {
        this.showAcceuil = false;
        this.showModeration = true;
        this.showHistorique = true;
        this.showReporting = false;
        this.showFacturation = false;
        this.showAdministration = false;
        break;
      }
      default:
        this.showAcceuil = false;
        this.showModeration = false;
        this.showHistorique = false;
        this.showReporting = false;
        this.showFacturation = false;
        this.showSupervision = false;
        this.showAdministration = false;
    }
  }

  multipleStyle(objectList : object[] ) : object {
    var obj = {};
    objectList.forEach((x : any) => {
      for (let i in x)
        obj[i] = x[i];
    });
    return obj;
  }

  defaultHeaderStyle() : object {
    return {"background-color":"#de7d3e", "border-color":"#de7d3e", "margin" : "1px 8px"};
  }
  buttonMenuStyle() : object {
    return {"width" : "130px"}
  }
  menuStyle() : object {
    return {
      "width":"100%",
      "background-color":"#f9f7f5",
      "color":"#de7d3e",
      "border-color":"#de7d3e"
    }
  }

  logout() {
    localStorage.removeItem("user");
    localStorage.removeItem("secondCq");
    localStorage.removeItem("second");
    this.loginService.logout().subscribe((loggedOut) => {
      console.log('Done');
      localStorage.clear();
      this.router.navigate(['/login']);
    });
  }

  afficherMenu() {
    this.visibleMenu = true;
  }


  buildMdenu(){
    let id_droit= parseInt(( JSON.parse(this.encryptService.decrypt(localStorage.getItem("user"))).droit ));

    switch (id_droit) {
      case 1:
      {
        return [
          {label:"Modération", icon:"pi pi-fw pi-id-card", routerLink:'/moderation'},
          {label:"Historique", icon:"pi pi-fw pi-clock", routerLink:'/historique'},
          {label:"Reporting", icon:"pi pi-fw pi-chart-line", routerLink:'/reporting'},
          {label:"Facturation", icon:"pi pi-fw pi-money-bill", routerLink:'/facturation'},
          {label:"Supervision", icon:"pi pi-fw pi-eye", routerLink:'/supervision'},
          {label:"Performance", icon:"pi pi-fw pi-chart-bar", routerLink:'/performance'},
        ]
        break;
      }
      case 2:
      {

        return [
          {label:"Modération", icon:"pi pi-fw pi-id-card", routerLink:'/moderation'},
          {label:"Historique", icon:"pi pi-fw pi-clock", routerLink:'/historique'},
          {label:"Reporting", icon:"pi pi-fw pi-chart-line", routerLink:'/reporting'},
          {label:"Facturation", icon:"pi pi-fw pi-money-bill", routerLink:'/facturation'},
          {label:"Supervision", icon:"pi pi-fw pi-eye", routerLink:'/supervision'},
          {label:"Performance", icon:"pi pi-fw pi-chart-bar", routerLink:'/performance'},
        ]
        
        break;
      }
      case 3:
      {
        return [
          {label:"Historique", icon:"pi pi-fw pi-clock", routerLink:'/historique'},
          {label:"Reporting", icon:"pi pi-fw pi-chart-line", routerLink:'/reporting'},
          {label:"Facturation", icon:"pi pi-fw pi-money-bill", routerLink:'/facturation'},
          {label:"Supervision", icon:"pi pi-fw pi-eye", routerLink:'/supervision'}
        ]
        
        break;
      }
      case 4:
      {
        return [
          {label:"Modération", icon:"pi pi-fw pi-id-card", routerLink:'/moderation'},
          {label:"Historique", icon:"pi pi-fw pi-clock", routerLink:'/historique'},
          {label:"Performance", icon:"pi pi-fw pi-chart-bar", routerLink:'/performance'},
        ]
        break;
      }
      case 5:
      {
        return [
          {label:"Modération", icon:"pi pi-fw pi-id-card", routerLink:'/moderation'},
          {label:"Historique", icon:"pi pi-fw pi-clock", routerLink:'/historique'},
          {label:"Performance", icon:"pi pi-fw pi-chart-bar", routerLink:'/performance'},
        ]
        break;
      }
      default:
        return [];
    }
  }
}
